import { Link } from "react-router-dom";
import { company } from "@/mocks/company";

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-10 py-14 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-brush-ai-line text-xl"></i>
            </span>
            <span className="font-heading text-lg text-background-50">株式会社 DAISAN</span>
          </div>
          <p className="text-sm text-background-200/90 leading-relaxed text-justify">
            マンション日常清掃を軸に、20年の実務経験と不動産オーナー視点で、地元・低価格・丁寧なサービスをお届けします。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-background-50 mb-4 text-sm tracking-widest">ホーム</h4>
          <ul className="space-y-2.5 text-sm text-background-200/90">
            <li><a href="/#top" className="hover:text-primary-300 cursor-pointer">TOP</a></li>
            <li><a href="/#strength" className="hover:text-primary-300 cursor-pointer">私たちの強み</a></li>
            <li><a href="/#services" className="hover:text-primary-300 cursor-pointer">サービス一覧</a></li>
            <li><a href="/#about" className="hover:text-primary-300 cursor-pointer">DAISANについて</a></li>
            <li><a href="/#case" className="hover:text-primary-300 cursor-pointer">事例紹介</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-background-50 mb-4 text-sm tracking-widest">会社情報</h4>
          <ul className="space-y-2.5 text-sm text-background-200/90">
            <li><Link to="/about" className="hover:text-primary-300 cursor-pointer">私たちについて</Link></li>
            <li><Link to="/company" className="hover:text-primary-300 cursor-pointer">会社概要</Link></li>
            <li><Link to="/faq" className="hover:text-primary-300 cursor-pointer">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-background-50 mb-4 text-sm tracking-widest">お問い合わせ</h4>
          <ul className="space-y-2.5 text-sm text-background-200/90">
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5"></i>
              <span>{company.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line"></i>
              <a href="tel:092-984-5214" className="hover:text-primary-300 cursor-pointer">{company.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <a href={`mailto:${company.email}`} className="hover:text-primary-300 cursor-pointer">{company.email}</a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              <span>{company.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-accent-900">
        <div className="mx-auto max-w-7xl px-4 md:px-10 py-6">
          <p className="text-xs text-background-300/80 text-center">
            © {new Date().getFullYear()} 株式会社DAISAN All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}